import { render, staticRenderFns } from "./CASEAssociatedItemTree.vue?vue&type=template&id=a25c31bc"
import script from "./CASEAssociatedItemTree.vue?vue&type=script&lang=js"
export * from "./CASEAssociatedItemTree.vue?vue&type=script&lang=js"
import style0 from "./CASEAssociatedItemTree.vue?vue&type=style&index=0&id=a25c31bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports